import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { HomeDto } from '../dto/home';
import { CodeService } from '../shared';
import { Store } from '@ngrx/store';
import * as IndicatorStore from '../store/indicator';
import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NoticeBoard } from '../dto';
@Injectable({
  providedIn: 'root',
})
export class HomeService extends BaseService {
  MAIN_CATEGORIES = ['001', '002', '003', '004'];
  MARKETING_CATEGORIES = [
    {
      code: '001003',
      id: 19,
      src: '../../assets/images/pc/img-masks-packs.png',
    },
    {
      code: '001003001',
      id: 20,
      src: '../../assets/images/pc/img-sheet-masks.png',
    },
    {
      code: '001001',
      id: 2,
      src: '../../assets/images/pc/img-cleansers.png',
    },
    {
      code: '001002',
      id: 10,
      src: '../../assets/images/pc/img-facial-care.png',
    },
    {
      code: '001004001',
      id: 28,
      src: '../../assets/images/pc/img-suncream.png',
    },
    {
      code: '002001',
      id: 34,
      src: '../../assets/images/pc/img-face.png',
    },
    {
      code: '002003',
      id: 49,
      src: '../../assets/images/pc/img-lip.png',
    },
    {
      code: '002002',
      id: 43,
      src: '../../assets/images/pc/img-eye.png',
    },
    {
      code: '003002',
      id: 67,
      src: '../../assets/images/pc/img-hair.png',
    },
    {
      code: '003001',
      id: 59,
      src: '../../assets/images/pc/img-body.png',
    },
  ];

  constructor(private codeService: CodeService, private store: Store<any>) {
    super();
  }

  getMarketingDisplayCategory() {
    return this.MARKETING_CATEGORIES.map((category) => this.codeService.getDisplayCategoryAsValue(category.code));
  }

  getMainDisplayCategory() {
    return this.MAIN_CATEGORIES.map((code) => this.codeService.getDisplayCategoryAsValue(code));
  }

  getHome(language: string) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('getHome'));
    return super
      .get<HomeDto>('/home2', { language })
      .pipe(
        mergeMap((homeDto) => {
          this.store.dispatch(new IndicatorStore.HideIndicator('getHome'));
          return of(homeDto);
        })
      );
  }

  // 공지 API
  getNotice(language: string) {
    this.store.dispatch(new IndicatorStore.ShowIndicator('getNotice'));
    return super
      .get<NoticeBoard[]>('/notice-board/main', { language })
      .pipe(
        mergeMap((notice) => {
          this.store.dispatch(new IndicatorStore.HideIndicator('getNotice'));
          return of(notice);
        })
      );
  }
}
